"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const attempt_serializer_1 = require("../serializers/attempt.serializer");
const sdk_constants_1 = require("../../constants/sdk.constants");
const attempt_rubric_selection_serializer_1 = require("../serializers/attempt-rubric-selection.serializer");
class AttemptClient {
    static newInstance(options, retryOptions) {
        return new AttemptClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new attempt_serializer_1.AttemptSerializer(), new attempt_rubric_selection_serializer_1.AttemptRubricSelectionSerializer());
    }
    constructor(client, serializer, attemptRubricSelectionSerializer) {
        this.client = client;
        this.serializer = serializer;
        this.attemptRubricSelectionSerializer = attemptRubricSelectionSerializer;
    }
    async findOneById(id, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts/${id}`, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async findByAssignee(assigneeId, filters, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.findByAssignee`, {
            headers,
            params: { assigneeId, ...filters, ...pageableOptions },
        });
        return this.serializer.serialize(response.body);
    }
    async start(attemptId, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.start/${attemptId}`, {}, { headers });
    }
    async submit(attemptId, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.submit/${attemptId}`, {}, { headers });
    }
    async sync(attemptId, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.sync`, { attemptId }, {
            headers,
        });
    }
    async findByAssessment(assessmentId, assigneeId, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.findByAssessment`, {
            headers,
            params: { assessmentId, assigneeId, ...pageableOptions },
        });
        return this.serializer.serialize(response.body);
    }
    async upsertFeedback(attemptId, feedback, headers) {
        const response = await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.feedback`, { attemptId, feedback }, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async grade(attemptId, items, headers) {
        const response = await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.grade`, { attemptId, items }, {
            headers,
        });
        return this.serializer.serializeOne(response.body.data);
    }
    async startCompletedOnPaper(attemptId, headers) {
        const response = await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.startCompletedOnPaper`, { attemptId }, {
            headers,
        });
        return this.serializer.serializeOne(response.body.data);
    }
    async delete(attemptId, headers) {
        await this.client.delete(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts/${attemptId}`, {
            headers,
        });
    }
    async getMultipleAttemptsFeedback(attemptsFeedbackRequestDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.feedback`, {
            attemptIds: attemptsFeedbackRequestDto.attemptIds,
        }, {
            headers,
        });
        return response.body.data;
    }
    async getAttemptFeedback(attemptId, assigneeId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.feedback/${attemptId}`, {
            headers,
            params: { assigneeId },
        });
        return this.serializer.serializeOne(response.body.data);
    }
    async findStatusByAssessment(assessmentIds, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.findStatusByAssessment`, {
            headers,
            params: { assessmentId: assessmentIds },
        });
        const { data } = response.body;
        return data;
    }
    async getRubricSelection(attemptId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/attempts.getRubricSelection/${attemptId}`, {
            headers,
        });
        return this.attemptRubricSelectionSerializer.serialize(response.body);
    }
}
exports.AttemptClient = AttemptClient;
//# sourceMappingURL=attempt.client.js.map